export function formatViews(n: number): string {
  if (n >= 100000) {
    return `${(n / 10000).toFixed(1)}万`;
  }
  if (n >= 10000) {
    return `${Math.round(n / 10000)}万`;
  }
  return String(n);
}

export function toDateTimeLabel(dateLabel: string, timeLabel: string): string {
  return `${dateLabel} ${timeLabel}`;
}